<template>
  <div class="px-12 mb-15 d-flex flex-column justify-center align-center">
    <ProgressBar :progress="progress" />
    <v-btn rounded plain text color="blue" @click="showCancelDialog = true">{{
      $t('common.cancel')
    }}</v-btn>
    <CancelDialog
      :show="showCancelDialog"
      @close="showCancelDialog = false"
      @confirm="$emit('cancel')"
    />
  </div>
</template>

<script>
import ProgressBar from '@/ui/excel/components/ProgressBar.vue'
import CancelDialog from '@/ui/excel/components/CancelDialog.vue'

export default {
  name: 'Loading',

  components: {
    ProgressBar,
    CancelDialog,
  },

  props: {
    progress: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      showCancelDialog: false,
    }
  },
}
</script>

<style></style>
